import { ChangeDetectionStrategy, Component } from '@angular/core'
import { combineLatest } from 'rxjs'
import { BreadcrumbMeta, CmsService, WindowRef } from '@spartacus/core'
import { MbContentPageMetaResolver } from '../page/mb-content-page-meta-resolver'
import { BreakpointObserver } from '@angular/cdk/layout'
import { map } from 'rxjs/operators'
import { CurrentProductService } from '@spartacus/storefront'
import { CmsBreadcrumbMeta } from '../components/types'
import { MbDocumentService } from '../services/mb-document-service/mb-document.service'
import { DeviceDetectorService } from 'ngx-device-detector'
import { MbPageMetaService } from '../page/mb-page-meta.service'

@Component({
  selector: 'mb-breadcrumb',
  templateUrl: './mb-breadcrumb.component.html',
  styleUrls: ['./mb-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbBreadcrumbComponent {

  state$ =  combineLatest([
    this.breakpoint.observe('(max-width: 991px)'),
    this.pageMetaService.getMeta()
  ]).pipe(
    map(([breakpointState, meta]) => {
        const isLG = this.winRef.isBrowser() ? !breakpointState.matches : this.deviceDetectorService.isDesktop()
        const breadcrumbs = meta?.breadcrumbs ? this.createBreadcrumb(meta.breadcrumbs, isLG) : null
        return {
          isLG,
          breadcrumbs
        }
      }
    ))

  constructor (private mbPageMetaResolver: MbContentPageMetaResolver,
               private breakpoint: BreakpointObserver,
               private currentProductService: CurrentProductService,
               private cmsService: CmsService,
               private documentService: MbDocumentService,
               private winRef: WindowRef,
               private deviceDetectorService: DeviceDetectorService,
               private pageMetaService: MbPageMetaService
  ) {
  }

  createBreadcrumb (breadcrumbs: BreadcrumbMeta[], isLG: boolean): CmsBreadcrumbMeta[] {
    if (this.winRef.isBrowser() ? !isLG : !this.deviceDetectorService.isDesktop()) {
      breadcrumbs = breadcrumbs?.filter(breadcrumb => breadcrumb.link?.length) || []
      breadcrumbs = breadcrumbs.length === 0
        ? []
        : breadcrumbs.length <= 2
          ? [breadcrumbs[breadcrumbs.length - 1]]
          : [breadcrumbs[breadcrumbs.length - 2]]
    }
    const slot = this.documentService.querySelector('cx-page-slot.BottomHeaderSlot')
    if (!breadcrumbs?.length) {
      if (slot?.classList && !slot.classList.contains(this.emptyClass)) {
        slot.classList.add(this.emptyClass)
      }
    } else {
      if (slot?.classList && slot.classList.contains(this.emptyClass)) {
        slot.classList.remove(this.emptyClass)
      }
    }
    return breadcrumbs
  }

  readonly emptyClass = 'empty-breadcrumb'
}
